module.exports = __webpack_public_path__ + "img/box.1070e173.png";